/**
 * 修改密码弹窗组件
 */

import { Modal, Form, Input } from "antd";
import { FormInstance } from "antd/lib/form";
import CustomButton from "../../../components/CustomButton";
import styles from "../Profile.module.css";

interface ChangePasswordModalProps {
  open: boolean;
  loading: boolean;
  form: FormInstance;
  onCancel: () => void;
  onFinish: (values: any) => void;
}

const passwordValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error("請輸入密碼"));
  }
  if (value.length < 8) {
    return Promise.reject(new Error("密碼長度不少於8位"));
  }

  let categories = 0;
  if (/[a-z]/.test(value)) categories++;
  if (/[A-Z]/.test(value)) categories++;
  if (/[0-9]/.test(value)) categories++;
  if (new RegExp("[~!@#%*,. /\\-_+]").test(value)) categories++;

  if (categories < 2) {
    return Promise.reject(new Error("須包含小寫英文字母、大寫英文字母、數字、特殊符號中的兩種"));
  }
  return Promise.resolve();
};

export function ChangePasswordModal({ open, loading, form, onCancel, onFinish }: ChangePasswordModalProps) {
  return (
    <Modal title="修改密碼" open={open} onCancel={onCancel} footer={null} width={440} centered>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="oldPassword" label="舊密碼" rules={[{ required: true, message: "請輸入舊密碼" }]}>
          <Input.Password size="large" placeholder="請輸入舊密碼" />
        </Form.Item>

        <Form.Item name="newPassword" label="新密碼" rules={[{ validator: passwordValidator }]}>
          <Input.Password size="large" placeholder="請輸入新密碼" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="確認新密碼"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "請輸入確認新密碼" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("兩次輸入的密碼不一致"));
              },
            }),
          ]}
        >
          <Input.Password size="large" placeholder="請再次輸入新密碼" />
        </Form.Item>

        <div className={styles.passwordHint}>
          密碼長度不少於8位，須包含小寫英文字母、大寫英文字母、數字、特殊符號中的兩種
          <br />
          特殊符號：~ ! @ # % * , . / - _ +
        </div>

        <div className={styles.modalFooter}>
          <CustomButton height="40px" bgColor="#fff" color="#666" style={{ border: "1px solid #d9d9d9" }} onClick={onCancel}>
            取消
          </CustomButton>
          <CustomButton bgColor="#00C7B6" height="40px" loading={loading} className={styles.submitBtn} onClick={() => form.submit()}>
            確認修改
          </CustomButton>
        </div>
      </Form>
    </Modal>
  );
}
